import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { BLOCS } from "../../../../../utils/data/models";
import * as dataActions from "../../../../../utils/data/dataActions";

class BlocPage extends React.Component {
  constructor(props) {
    super(props);

    this.getData = this.getData.bind(this);
  }

  getChildContext() {
    return {
      getData: this.getData,
    };
  }

  componentDidMount() {
    this.getData();
  }

  componentWillUpdate(nextProps) {
    if (this.props.blocId !== nextProps.blocId) {
      this.getData(nextProps.blocId);
    }
  }

  getData(blocId) {
    if (!blocId) {
      blocId = this.props.blocId;
    }

    this.props.dataActions.getDataItem(BLOCS, blocId, {
      fields: "*,acombaInsurers(*),acombaTaxes(*)",
    });
  }

  render() {
    const { children } = this.props;
    return !!children ? children : "";
  }
}

BlocPage.propTypes = {
  children: PropTypes.node,
  dataActions: PropTypes.object,
  blocId: PropTypes.string,
};

BlocPage.childContextTypes = {
  getData: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
  return {
    blocId: ownProps.params.blocId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BlocPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/bloc/BlocPage.js